import px from 'prop-types';

export const LinkItemShape = {
    href: px.string.isRequired,
    target: px.string,
};

export default px.shape(LinkItemShape);
